import { gql } from '@apollo/client'

const EDIT_PATIENT_REFERENCE_ID = gql`
  mutation EDIT_PATIENT_REFERENCE_ID($patient: ID!, $referenceId: Int!) {
    editPatientReferenceId(patient: $patient, referenceId: $referenceId) {
      id
      referenceId
    }
  }
`

export default EDIT_PATIENT_REFERENCE_ID
